import GameLobby from "@/data/GameLobby";
import { PlayerSocket, QuestMissionState } from "@/data/redux/questSlice";
import { useAppStore } from "@/data/redux/store";
import { ISaveData } from "@/data/types";
import { env } from "@/env";
import PersistenceService from "@/services/list-builder/PersistenceService";
import { useEffect } from "react";
import { io } from "socket.io-client";

export interface JoinData {
  lobbyId: string;
  lobbyHost: PlayerSocket;
  lobbyClients: PlayerSocket[];
  mission: QuestMissionState;
  collection: ISaveData;
}

const socketUrl = env.NEXT_PUBLIC_LOBBY_URL;

export function useGameLobby() {
  const store = useAppStore();
  useEffect(() => {
    if (GameLobby.socket?.active) return;

    GameLobby.socket = io(socketUrl);

    GameLobby.socket.onAny((...args: any[]) => {
      if (!args[0].startsWith("ping")) console.log("%c Event", "color: #BB86FC;", args);
    });

    GameLobby.socket.onAnyOutgoing((...args: any[]) => {
      if (!args[0].startsWith("ping")) console.log("%c Emit", "color: #03DAC5;", args);
    });

    GameLobby.socket.on("ping", (clientId) => {
      const lobby = store.getState().quest.mission?.lobby;

      if (!lobby || lobby.host?.playerId !== lobby.playerId) return;

      GameLobby.socket.emit("ping_ack", clientId);
    });

    GameLobby.socket.on("client_inquire", (clientId) => {
      const { quest } = store.getState();
      const lobby = quest.mission?.lobby;

      if (!lobby || lobby.host?.playerId !== lobby.playerId) return;

      GameLobby.socket.emit("client_inquire_ack", clientId, {
        slots: quest.mission.heroes.length
      });
    });

    GameLobby.socket.on("request_state", (clientId) => {
      const { quest, list } = store.getState();
      const lobby = quest.mission?.lobby;

      if (!lobby || lobby.host?.playerId !== lobby.playerId) return;

      const collection = PersistenceService.getSaveData(list.id);
      const joinData: JoinData = {
        lobbyId: lobby.id,
        lobbyHost: lobby.host,
        lobbyClients: lobby.clients,
        collection: JSON.parse(collection),
        mission: quest.mission
      };
      GameLobby.socket.emit("request_state_ack", clientId, joinData);
    });

    GameLobby.socket.on("client_request_join", (socketId: string, playerId: string) => {
      const { quest, list } = store.getState();
      const lobby = quest.mission?.lobby;

      if (!lobby || lobby.host?.playerId !== lobby.playerId) return;

      const collection = PersistenceService.getSaveData(list.id);

      const joinData: JoinData = {
        lobbyId: lobby.id,
        lobbyHost: lobby.host,
        lobbyClients: lobby.clients.concat({ socketId, playerId }),
        collection: JSON.parse(collection),
        mission: quest.mission
      };

      GameLobby.socket.emit("client_join_approved", socketId, joinData);
    });
  }, [store]);
}
